export default __webpack_public_path__ + "static/media/featured.d0fb6661.png";